import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Clickable branding: logo + "EmergencyQR" + "By Ditya Technologies".
 * Click navigates to home (/).
 * Use in headers across all pages; replace separate logo + Home button.
 */
const BrandLogo = ({ className = "", logoClassName = "", textClassName = "", variant = "default" }) => {
  const navigate = useNavigate();
  const isLight = variant === "light"; // e.g. on red/dark header
  const textColor = isLight ? "text-white" : "text-slate-900";
  const accentColor = isLight ? "text-red-200" : "text-red-600";
  const subColor = isLight ? "text-white/80" : "text-slate-500";

  return (
    <button
      type="button"
      onClick={() => navigate("/")}
      className={`flex items-center gap-2 shrink-0 focus:outline-none focus:ring-2 focus:ring-red-500/50 focus:ring-offset-2 rounded-lg transition-opacity hover:opacity-90 ${className}`}
      aria-label="Go to home"
    >
      <img
        src="/logo-emergency-qr.png?v=4"
        alt="Emergency QR"
        className={`h-8 w-auto object-contain ${logoClassName}`}
      />
      <div className={`leading-tight text-left ${textClassName}`}>
        <span className={`text-sm font-extrabold block ${textColor}`}>
          Emergency<span className={accentColor}>QR</span>
        </span>
        <span className={`text-[10px] font-medium block ${subColor}`}>By Ditya Technologies</span>
      </div>
    </button>
  );
};

export default BrandLogo;
